import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { GungNotificationService } from 'gung-common';
import { ConfigurationsService, GungConfiguration } from '../../../services/configurations.service';
import { GungSettingsBaseViewComponent } from '../../gung-settings-base-view/gung-settings-base-view.component';

@Component({
  selector: 'lib-gung-settings-sepa-direct-debit',
  standalone: false,
  templateUrl: './gung-settings-sepa-direct-debit.component.html',
  styleUrl: './gung-settings-sepa-direct-debit.component.scss'
})
export class GungSettingsSepaDirectDebitComponent extends GungSettingsBaseViewComponent implements OnInit {
  protected formBuilder = inject(FormBuilder);
  protected configurationsService = inject(ConfigurationsService);
  protected gungNotificationService = inject(GungNotificationService);
  protected translateService = inject(TranslateService);

  public form: FormGroup;
  protected configuration: GungConfiguration;
  public creditInformation: any;
  public loaded = false;

  ngOnInit(): void {
    this.configurationsService.getConfigurationsByIds(['SepaCreditorInformationConfig'], true).subscribe(configs => {
      if (!configs || configs.length == 0) {
        return;
      }

      this.configuration = configs[0];
      this.initForm();
      this.loaded = true;
    });
  }

  initForm() {
    this.form = this.formBuilder.group({
      name: this.formBuilder.control(this.configuration.name),
      creditorId: this.formBuilder.control(this.configuration.creditorId),
      iban: this.formBuilder.control(this.configuration.iban),
      bic: this.formBuilder.control(this.configuration.bic),
      sepaAgreementNumber: this.formBuilder.control(this.configuration.sepaAgreementNumber)
    });
  }

  save() {
    this.configuration.name = this.form.value.name;
    this.configuration.creditorId = this.form.value.creditorId;
    this.configuration.iban = this.form.value.iban;
    this.configuration.bic = this.form.value.bic;
    this.configuration.sepaAgreementNumber = this.form.value.sepaAgreementNumber;
    this.configurationsService.updateConfiguration(this.configuration).subscribe({
      next: _ => {
        this.gungNotificationService.notify(
          this.translateService.instant('CREDITOR_INFORMATION_SAVED'),
          null,
          'success'
        );
      },
      error: err => {
        const message = err?.error?.message || this.translateService.instant('ERROR_SAVING_CREDITOR_INFORMATION');
        this.gungNotificationService.notify(message, null, 'danger');
      }
    });
  }
}
